<template>
  <v-card>
    <v-card-title primary-title class="greyk lighten-4k">
      <h4 class="headline mb-0">{{ $t('employees') }}</h4>
      <v-btn icon color="primary" @click="showD=!showD" class="elevation-5">
        <v-icon>add</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab v-for="item in tabitems" :key="item">
          <span style="font-weight:bold">{{ item }}</span>
        </v-tab>
      </v-tabs>

      <v-divider></v-divider>

      <v-tabs-items v-model="tab">
        <!-- teachers tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searcht"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                style="max-width:40%"
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="teachers_headers"
                :items="teachers"
                class="elevation-0"
                :search="searcht"
                :loading="tloading"
              >
                <template v-slot:items="props">
                  <td>{{ props.index + 1 }}</td>
                  <td>
                    <v-img
                      :src="'/images/avatars/'+props.item.avatar"
                      lazy-src="../../../../img/user.jpg"
                      alt="profile pic"
                      class="mt-2"
                      style="width:50px;height:50px;border-radius:50%"
                      v-if="props.item.avatar"
                    />
                    <img
                      src="../../../../img/user.jpg"
                      alt="profile pic"
                      class="mt-2"
                      style="width:50px;height:50px;border-radius:50%"
                      v-else
                    />
                  </td>
                  <td class="text-xs-center">{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.email?props.item.email:'N/A' }}</td>
                  <td class="text-xs-center">{{ props.item.phone?props.item.phone:'N/A' }}</td>
                  <td
                    class="text-xs-center"
                  >{{ props.item.t_classes?commaSeperatedClasses(props.item.t_classes):'N/A' }}</td>
                   <td class="text-xs-center">{{ props.item.status && props.item.status ==1?"Active" : "Inactive" }}</td>
                  <td class="text-xs-center">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-btn flat icon color="blue" @click="editemployee(props.item,'tca')">
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs6>
                        <v-btn
                          flat
                          icon
                          color="pink"
                          @click="deleteemployee(props.item,props.index,'tca')"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- other staffs tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searcho"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                style="max-width:40%"
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="ostaffs_headers"
                :items="oemployees"
                class="elevation-0"
                :search="searcho"
                :loading="loading"
              >
                <template v-slot:items="props">
                  <td>{{ props.index + 1 }}</td>
                  <td>
                    <v-img
                      :src="'/images/avatars/'+props.item.avatar"
                      lazy-src="../../../../img/user.jpg"
                      alt="profile pic"
                      class="mt-2"
                      style="width:50px;height:50px;border-radius:50%"
                      v-if="props.item.avatar"
                    />
                    <img
                      src="../../../../img/user.jpg"
                      alt="profile pic"
                      class="mt-2"
                      style="width:50px;height:50px;border-radius:50%"
                      v-else
                    />
                  </td>
                  <td class="text-xs-center">{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.email?props.item.email:'N/A' }}</td>
                  <td class="text-xs-center">{{ props.item.phone?props.item.phone:'N/A' }}</td>
                  <td class="text-xs-center">{{ props.item.roles?props.item.roles[0].name:'N/A' }}</td>
                   <td class="text-xs-center">{{ props.item.status && props.item.status ==1?"Active" : "Inactive" }}</td>

                  <td class="text-xs-center">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-btn flat icon color="blue" @click="editemployee(props.item,'oemp')">
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs6>
                        <v-btn
                          flat
                          icon
                          color="pink"
                          @click="deleteemployee(props.item,props.index,'oemp')"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <!-- add-edit employee dialog -->
    <m-dialog pers title="Employee" :show="showD">
      <template v-slot:header-actions>
        <v-btn @click="showD=!showD" icon style="cursor:pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>

      <template v-slot:content>
        <v-form ref="form">
          <div style="text-align:center">
            <profile-img
              field="img"
              @crop-success="cropSuccess"
              v-model="showCrop"
              :width="300"
              :height="300"
              img-format="png"
              langType="en"
              :noCircle="true"
            ></profile-img>

            <v-img
              v-if="imgDataUrl"
              :src="imgDataUrl"
              width="150px"
              height="150px"
              style="display:block;margin:0 auto;border-radius:10px"
            />
            <v-btn
              @click="showCrop=!showCrop"
              color="primary"
              style="margin-top:10px;border-radius:20px"
            >select image</v-btn>
          </div>
           <v-switch
            :true-value="1"
            :false-value="0"
            v-model="employee_model.status"
            label="Account Status"
            v-if="editedIndex>-1"
          ></v-switch>
          <v-text-field label="Name" v-model="employee_model.name" :rules="validRules.required" />
          <v-text-field label="Email" v-model="employee_model.email" :rules="validRules.email" />
          <v-text-field label="Phone" v-model="employee_model.phone" :rules="validRules.required" />
          <v-text-field
            label="Password"
            v-model="employee_model.password"
            :rules="editedIndex>-1?[]:validRules.password"
            :counter="true"
          />
          <v-select
            :items="user_roles"
            item-text="name"
            item-value="name"
            label="Role"
            v-model="employee_model.selected_role"
            :rules="validRules.required"
          ></v-select>
          <!-- <v-text-field label="Photo" v-model="employee_model.avatar" /> -->
        </v-form>
      </template>

      <template v-slot:footer-actions>
        <v-btn style="cursor:pointer" color="success" @click="saveemployee()">save</v-btn>
        <v-btn @click="showD=!showD" style="cursor:pointer" color="error">close</v-btn>
      </template>
    </m-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "../../../components/Modal";
import profileImg from "vue-image-crop-upload";
export default {
  name: "employee-view",
  layout: "admin",
  metaInfo() {
    return { title: this.$t("employees") };
  },
  components: {
    "m-dialog": Modal,
    profileImg
  },
  data() {
    return {
      showD: false,
      searcht: "",
      searcho: "",
      tab: null,
      showCrop: false,
      imgDataUrl: "",
      editedIndex: -1,
      updatefrom: "",
      employee_model: {
        name: "",
        email: "",
        phone: "",
        password: "",
        avatar: "",
        selected_role: "",
        roles: [],
        avatar_data:'',
        status:1
      },
      employee_modelcp: {
        name: "",
        email: "",
        phone: "",
        password: "",
        avatar: "",
        selected_role: "",
        roles: [],
        avatar_data:'',
        status:1
      },
      tabitems: ["Teachers", "Other Staff"],

      teachers_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Image",
          align: "center",
          sortable: false,
          value: "class"
        },
        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "name"
        },
        ,
        {
          text: "Email",
          align: "center",
          sortable: true,
          value: "email"
        },
        {
          text: "Phone",
          align: "center",
          sortable: true,
          value: "capacity"
        },
        {
          text: "Assigned Classes",
          align: "center",
          sortable: false,
          value: "class"
        },
         {
          text: "Acct. Status",
          align: "center",
          sortable: false,
          value: "status"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "name"
        }
      ],
      ostaffs_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Image",
          align: "center",
          sortable: false,
          value: "class"
        },
        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "name"
        },
        ,
        {
          text: "Email",
          align: "center",
          sortable: true,
          value: "email"
        },
        {
          text: "Phone",
          align: "center",
          sortable: true,
          value: "capacity"
        },
        {
          text: "Role",
          align: "center",
          sortable: true,
          value: "roles"
        },
        {
          text: "Acct. Status",
          align: "center",
          sortable: false,
          value: "status"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "name"
        }
      ]
    };
  },

  mounted() {
    this.$store.dispatch("oemployees/getAll");

    this.$store.dispatch("teachers/getAll");

    this.$store.dispatch("userroles/getAll", { page: "emps" });

    //console.log("oemployeeooooo",oemployee)
    // console.log("roles",this.user_roles)
  },
  computed: {
    ...mapGetters({
      oemployees: "oemployees/OEMPLOYEES",
      eerrors: "oemployees/OEMPLOYEE_ERROR",
      loading: "oemployees/OEMPLOYEE_LOADING",

      teachers: "teachers/TEACHERS",
      terrors: "teachers/TEACHER_ERROR",
      tloading: "teachers/TEACHER_LOADING",

      user_roles: "userroles/USERROLES"
    }),

  },
  methods: {
    cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
      this.employee_model.avatar_data = imgDataUrl;
    },
    addemployee() {
      this.employee_model.roles = this.employee_model.selected_role
        ? [this.employee_model.selected_role]
        : []; //setting emp role
      if (this.employee_model.selected_role == "teacher") {
        // console.log(this.employee_model)

        this.$store.dispatch("teachers/add", this.employee_model);
        if (this.terrors == null) {
          this.employee_model = {
            roles:[],
            status:1,
          };
          this.$store.dispatch("responseMessage", {
            type: "success",
            text: "Teacher added successfully.",
            title: "Employees",
            modal: false
          });
        }
      } else {
        this.$store.dispatch("oemployees/add", this.employee_model);
        if (this.eerrors == null) {
          this.employee_model = {
            roles:[],
            status:1,
          };
          this.$store.dispatch("responseMessage", {
            type: "success",
            text: "Employee added successfully.",
            title: "Employees",
            modal: false
          });
        }
      }
    },
    deleteemployee(employee, index, ftab) {
      //ftab = from which tab

      if (confirm("Are you sure you want to delete this employee?")) {
        if (ftab == "tca") {
          let idx = this.teachers.indexOf(employee);
          this.$store.dispatch("teachers/delete", { employee, index: idx });
        } else {
          let idx = this.oemployees.indexOf(employee);
          this.$store.dispatch("oemployees/delete", { employee, index: idx });
        }

        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Employee deleted successfully.",
          title: "Employees",
          modal: false
        });
      }
    },

    editemployee(employee, ftab) {
      //console.log("emmpp",employee)
      this.updatefrom = ftab;
      if (ftab == "tca") {
        this.editedIndex = this.teachers.indexOf(employee);
        this.employee_model = Object.assign({}, employee);
        this.employee_model.selected_role = employee.roles?employee.roles[0].name:'';
      } else {
        this.editedIndex = this.oemployees.indexOf(employee);
        this.employee_model = Object.assign({}, employee);
        this.employee_model.selected_role = employee.roles?employee.roles[0].name:'';
      }

       this.imgDataUrl =this.employee_model.avatar?'/images/avatars/'+this.employee_model.avatar:'../../../../img/user.jpg';
     // console.log(this.editedIndex)
      //alert(this.editedIndex)

      this.showD = true;
    },
    updateemployee(employee, index) {
      employee.roles = [this.employee_model.selected_role]; //switching to selected role before sending to backend
      //  console.log(employee)
      //  return
      if (this.updatefrom == "tca") {
        this.$store.dispatch("teachers/update", { index, employee });

        if (this.terrors == null) {
          if (employee.roles[0] != "teacher") {
            this.$store.dispatch("oemployees/getAll");
            this.$store.dispatch("teachers/getAll");
          }

          this.employee_model = {
            roles:[],
            status:1,
          };
          this.editedIndex = -1;
          this.showD = false;
          this.updatefrom = "";

          this.$store.dispatch("responseMessage", {
            type: "success",
            text: "Teacher details updated successfully.",
            title: "Employees",
            modal: false
          });
        }
      } else {
        // console.log(employee)
        // return
        this.$store.dispatch("oemployees/update", { index, employee });

        if (this.eerrors == null) {
          if (employee.roles[0] == "teacher") {
            this.$store.dispatch("teachers/getAll");
            this.$store.dispatch("oemployees/getAll");
          }

          this.employee_model = {
            roles:[],
            status:1,
          };;
          this.editedIndex = -1;
          this.showD = false;
          this.updatefrom = "";
          this.$store.dispatch("responseMessage", {
            type: "success",
            text: "Employee updated successfully.",
            title: "Employees",
            modal: false
          });
        }
      }
    },
    saveemployee(ftab) {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing employee info or saving employee info
      if (this.editedIndex > -1) {
        this.updateemployee(this.employee_model, this.editedIndex, ftab);
      } else {
        this.addemployee();
      }
    },

    commaSeperatedClasses(cls) {
      let class_names = cls.map(c => {
        return c.name;
      });

      return cls.length > 0 ? class_names.toString() : "N/A";
    }
  },
  watch: {
    showD(val) {
      if (val == false) {
        this.employee_model = {
            roles:[],
            status:1,
          };
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/employees/employees.vue